export default "__VITE_ASSET__dcf099ac__"